<template lang="pug">
div
  template(v-if="!pageLoading")
    .sgbox.mega.aaa
      .gbox
        #preloader(v-if="gameLaunching")
          #loader
        div(v-if="!pageLoading")
          template(v-if="listToDisplay.length > 0")
            .ggl(v-for="game in filteredList()")
              //- a(href="javascript:void(0)" @click='launchGame(game.GameCode)')
              router-link(v-if="isLoggedIn" :to="'/launchMega?game=' + game.GameCode" target="_blank")
                //- img(:src='game.ImageUrl')
                v-lazy-image(:src="game.ImageUrl" src-placeholder="/images/fallb/megaH5.png" @error="$helpers.handleImageError($event,'megaH5')")
                span {{game.GameName}} 
              a(v-else href="javascript:void(0)" @click="openModal('#modal-login')")
                //- img(:src="game.ImageUrl")
                v-lazy-image(:src="game.ImageUrl" src-placeholder="/images/fallb/megaH5.png" @error="$helpers.handleImageError($event,'megaH5')")
                span {{game.GameName}} 
              .progress
                .progress-bar.progress-bar-striped.progress-bar-animated(role="progressbar" :aria-valuenow='game.rtp' aria-valuemin="0" aria-valuemax="100" :style="'width: '+game.rtp+'%'") RTP {{game.rtp}}
  template(v-else)
    .text-white.my-2.text-center
      i.fas.fa-duotone.fa-spinner.fa-spin-pulse
</template>
<script>
import config from '@/config'
import _ from "lodash";
import VLazyImage from "v-lazy-image/v2";
export default {
  components: {
    VLazyImage,
  },
  props: {
    searchinput:{
      type: String,
      default: ""
    }
  },
  data(){
    return{
      feedback: {
        success: true,
        status: ""
      },
      gameList:[],
      imageUrl:"",
      page: 0,
      loading: false,
      pageLoading:false,
      gameLaunching: false,
      listToDisplay: [],
      offList:[],
      min: config.minE,
      max: config.max,
      precision: config.precision
    }
  },
  computed:{
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    getLanguage() {
      return this.$store.getters.language || "en"
    },
    matchedLocale(){
      switch(this.getLanguage){
        case "en":
          return "en"
        case "my":
          return "my"
        case "zh":
          return "zh-CN"
        default :
          return "en"
      }
    }
  },
  mounted(){
    // window.scroll(0,0)
    this.getProviderGameOfflist()
  },
  methods:{
    openModal(target){
      $(target).modal("show")
    },
    getProviderGameOfflist(){
      if (this.sessionToken) {
				var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        let provider_code = "MEGAH5"
        this.$store
          .dispatch("user/getProviderGameOfflist", { account_id, auth_token, provider_code })
          .then(response => {
            if (response.success == true) {
							this.offList = response.data
              this.getGameList()
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }else{
				this.getGameList()
			}
    },
    getGameList(){
      var vm = this
      this.pageLoading = true
			var url = config.getMegaH5GameList()
      this.$http.get(url).then(
        successResponse => {
          if(successResponse){
            if (typeof successResponse.data.status == "string") {
              this.feedback.success = successResponse.status == "200";
            } else {
              this.feedback.success = successResponse.status == 200;
            }
            this.feedback.status = successResponse.status;
            if (this.feedback.success == true) {
              var _0x227616=_0x48ff;function _0x55ab(){var _0x11da18=['bqgab','1507hhUabv','BpNbN','50DloIDO','116618oMKgyo','645309OtbSsj','rtp','pFWEJ','JQKLR','gameList','8604BFOcPL','2004JWlsfC','3035104HKxGUe','precision','1jtVDbI','toFixed','max','forEach','Game','min','QwFCl','45jweaPM','434LlmTTV','224985oegzHF','data','random','1516TEwPyM'];_0x55ab=function(){return _0x11da18;};return _0x55ab();}function _0x48ff(_0x4b645c,_0x4f522e){var _0x5e7a96=_0x55ab();return _0x48ff=function(_0x25a328,_0x2b36c3){_0x25a328=_0x25a328-(0x636+0x20fb*0x1+-0xceb*0x3);var _0x3b844b=_0x5e7a96[_0x25a328];return _0x3b844b;},_0x48ff(_0x4b645c,_0x4f522e);}(function(_0x377169,_0x1467bc){var _0x30aa91=_0x48ff,_0x4de3b2=_0x377169();while(!![]){try{var _0x493798=-parseInt(_0x30aa91(0x72))/(0xc05+-0xafb*-0x1+-0x1*0x16ff)*(-parseInt(_0x30aa91(0x83))/(-0xded+0xc4b*0x3+0xb*-0x216))+parseInt(_0x30aa91(0x7b))/(0x90c*-0x3+-0x1*-0xd76+0xdb1)+parseInt(_0x30aa91(0x7e))/(-0x1b1f+0x20e3+0x5c*-0x10)*(parseInt(_0x30aa91(0x79))/(0x868+0x9*-0x67+-0x4c4))+-parseInt(_0x30aa91(0x8a))/(-0x5d4+-0xf43+0x151d)*(parseInt(_0x30aa91(0x7a))/(0x4a6+0x1*-0x18cb+0x142c))+-parseInt(_0x30aa91(0x70))/(-0x2543+0x1fd*0x3+0x1f54)+-parseInt(_0x30aa91(0x84))/(-0x4*0x157+0x5f2+-0x8d)*(-parseInt(_0x30aa91(0x82))/(0x12be+-0x1*0x55d+-0xd57))+-parseInt(_0x30aa91(0x80))/(0x8d6+0xd87+-0x1652)*(-parseInt(_0x30aa91(0x89))/(-0x2*0x125+-0x225a*-0x1+-0x3*0xaac));if(_0x493798===_0x1467bc)break;else _0x4de3b2['push'](_0x4de3b2['shift']());}catch(_0x554797){_0x4de3b2['push'](_0x4de3b2['shift']());}}}(_0x55ab,0x321d*0x13+0x1c461+-0x2893f),this[_0x227616(0x88)]=successResponse[_0x227616(0x7c)][_0x227616(0x76)],this[_0x227616(0x88)][_0x227616(0x75)](function(_0xca4e6a){var _0x28bf09=_0x227616,_0x1492c5={'pFWEJ':_0x28bf09(0x85),'bqgab':function(_0x361836,_0x5c9ecf){return _0x361836(_0x5c9ecf);},'BpNbN':function(_0x2864cd,_0x3fd017){return _0x2864cd*_0x3fd017;},'JQKLR':function(_0x33fde5,_0x13b752){return _0x33fde5+_0x13b752;},'QwFCl':function(_0x574511,_0x22b3b9){return _0x574511-_0x22b3b9;}};_0xca4e6a[_0x1492c5[_0x28bf09(0x86)]]=_0x1492c5[_0x28bf09(0x7f)](parseFloat,_0x1492c5[_0x28bf09(0x81)](_0x1492c5[_0x28bf09(0x87)](_0x1492c5[_0x28bf09(0x81)](Math[_0x28bf09(0x7d)](),_0x1492c5[_0x28bf09(0x78)](vm[_0x28bf09(0x74)],vm[_0x28bf09(0x77)])),vm[_0x28bf09(0x77)])[_0x28bf09(0x73)](vm[_0x28bf09(0x71)]),-0x1*0x379+-0x1178*-0x1+-0x6ff*0x2))[_0x28bf09(0x73)](0x1d7d*0x1+-0x48*0x6c+0xe5*0x1);}));
              this.listToDisplay = this.gameList.filter(obj1 => 
                !this.offList.some(obj2 => obj1.GameCode === obj2.game_id)
              )
              this.pageLoading = false
            } else {
              this.pageLoading = false
            }
          }else{
            this.pageLoading = false
          }
        },
        errorResponse => {
          this.pageLoading = false
          console.log(errorResponse)
        }
      );
    },
    filteredList(){
      return this.listToDisplay.filter((game) =>
        game.GameName.toLowerCase().includes(this.searchinput.toLowerCase())
      );
    }
    // launchGame(game){
    //   if (this.sessionToken) {
    //     this.gameLaunching = true
		// 		var vm = this
    //     let player_id = this.accountID
    //     let auth_token = this.sessionToken
    //     let game_code = game
    //     let lang_code = "en"
    //     this.$store
    //       .dispatch("user/launchMegaH5", { player_id, auth_token,game_code, lang_code })
    //       .then(response => {
    //         if (response.success == true) {
		// 					setTimeout(() => {
		// 						window.open(response.data, "_blank")
    //             vm.gameLaunching = false
		// 					}) 
    //         } else {        
    //           vm.gameLaunching = false     
    //           if((typeof response.status) != 'object'){
    //             this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
    //           }
    //         }
    //       })
    //       .catch(response => {
    //         vm.gameLaunching = false
    //         if((typeof response.status) != 'object'){
    //           if(response.status === 'free_credit_detected'){
    //             this.$swal({
    //               title: vm.$tc("ui.attention"),
    //               text: vm.$tc("message.list.free_credit_detected"),
    //               showCancelButton: true,
    //               type: "info",
    //               confirmButtonText: vm.$tc("ui.ok"),
    //               cancelButtonText: vm.$tc("ui.deposit"),
    //             }).then(result => {
    //               if (result.value) {
    //                 // vm.$router.push("/slot").catch(error =>{})
    //                 vm.$store.dispatch("user/setSlotSelected", 0)
    //               } else if (result.dismiss) {
    //                 if(result.dismiss === 'cancel'){
    //                   vm.$router.push("deposit").catch(error =>{})
    //                 }
    //               }
    //             });
    //           }else{
    //             this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
    //           }
    //         }
    //       });
    //   }else{
		// 		this.$router.push('/login').catch(err => {})
		// 	}
    // }
  }
}
</script>